import React, {useEffect, useState} from "react";
import {CustomTablePagination, EnhancedSearchTableToolbar} from "../../Utils/Tables/CustomTable";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import *  as snackbarActions from "../../../actions/snackbarActions";
import MainSnackbar from "../../Utils/Snackbar/SmsSnackbar";
import {Container, RightAlignedContainer} from "../../Utils/styledComponents";
import axios from "axios";
import {config} from "../../../Helpers/env";
import {logoutErrorMessage} from "../../../Helpers/ErrorMessages";
import {LoadingGif} from "../../Utils/Loader";
import {CustomTableCell, MuiPaper, StickyHeadTable} from "../../Utils/Tables/StickyHeaderTable";
import PageTitle from "../../Utils/smsTitle";
import {SubHeader} from "../../../Containers/SubHeader";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClipboardList} from "@fortawesome/free-solid-svg-icons/faClipboardList";
import {BackButton, DataExportButton} from "../../Utils/Buttons/DataExportationButton";
import {useDebounce} from "../../Lab/useDebounce";
import {useExcelReports, usePdfDownload} from "../../Utils/ReusableComponents/useExcelExport";


const headData = [
    {id: 'count', numeric: false, disablePadding: false, label: 'Sl'},
    {id: 'provider_name', numeric: false, disablePadding: false, label: 'Provider Name'},
    {id: '0_to_30', numeric: false, disablePadding: false, label: '0-30 days'},
    {id: '31_to_60', numeric: false, disablePadding: false, label: `31-60 days`},
    {id: '61_to_90', numeric: false, disablePadding: false, label: `61-90 days`},
    {id: 'over_90', numeric: false, disablePadding: false, label: `Over 90 days`},
    {id: 'total', numeric: false, disablePadding: false, label: `Total`},
];

const DebtorsAgeingReport = ({actions, snackbars}) => {
    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [data, setData] = useState({debtors: [], loading: 'idle', total: 0});
    const [debouncedInputValue] = useDebounce(searchValue, 500)
    const [activePage, setActivePage] = useState(1)


    const {loading, debtors, total} = data

    useEffect(() => {
        setData(prev => ({...prev, loading: 'pending'}))
        axios.get(`${config.smsUrl}/accounting/debtors_summary`, {
            params: {
                search: debouncedInputValue,
                page: activePage,
                per_page: rowsPerPage
            }
        }).then(res => {
            const data = res.data;
            const dt = !data ? {} : data;
            const arr = dt.data ? dt.data : []
            const total_count = dt.total_count ? dt.total_count : 0
            setData(prev => ({...prev, loading: 'success', debtors: arr, total: total_count}))
        }).catch((err) => {
            setData(prev => ({...prev, loading: 'error'}))
            logoutErrorMessage(err, null, actions);
        })
    }, [debouncedInputValue, rowsPerPage, activePage, actions]);


    const handleSearch = (event) => {
        setSearchValue(event.target.value)
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setActivePage(newPage + 1)
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setActivePage(1);
    };

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar()
    };


    const params = {file_name: 'Debtors Ageing Summary', url: 'accounting/debtors_ageing_summary/export'}


    const {exportExcel, isLoading: isLoadingExcel} = useExcelReports(actions, {params:{download: 1}, ...params})
    const {exportPdf, isLoading: isLoadingPdf} = usePdfDownload(actions, {download: 2, ...params})


    const {openBar, type, message} = snackbars;

    const isLoading = loading === 'pending'
    const isSuccess = loading === 'success'
    const isError = loading === 'error'


    const pagination = (
        <CustomTablePagination
            colSpan={3}
            activePage={activePage}
            page={page}
            rowsPerPage={rowsPerPage}
            count={total}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            isTotalCount
        />
    );

    const search_bar = (
        <EnhancedSearchTableToolbar
            term={searchValue} handler={handleSearch}
        />
    )
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, debtors.length - page * rowsPerPage);

    return (
        <div data-testid={`debtors-ageing-summary`}>
            <PageTitle title='Debtors Ageing Summary'/>
            <SubHeader title="Reports" subTitle='Debtors Ageing Summary'>
                <FontAwesomeIcon icon={faClipboardList}/>
            </SubHeader>
            <Container>
                <div className="row">
                    <div className="col-lg-6">
                        <BackButton to='/reports/generalreports' text='General Reports'/>
                    </div>
                    <div className="col-lg-6">
                        <RightAlignedContainer>
                            <DataExportButton isLoading={isLoadingExcel || isLoadingPdf}  downLoadPdf={exportPdf} exportCsv={exportExcel}/>
                        </RightAlignedContainer>
                    </div>
                </div>
                <MainSnackbar variant={type} open={openBar} message={message} handleCloseBar={closeSnackbar}/>
                <MuiPaper>
                    {search_bar}
                    <StickyHeadTable {...{
                        width: '100%',
                        data: debtors,
                        columns: headData.filter(item => Boolean(item)),
                        pagination
                    }}>
                        {isLoading ? <TableRow><TableCell
                            align='center' {...{colSpan: headData.length}}><LoadingGif/></TableCell></TableRow> : null}
                        {isSuccess ? debtors.length > 0 ?
                            <>
                                {debtors.slice(0, rowsPerPage).map((row, index) => {
                                    const count = (page * rowsPerPage) + index + 1;
                                    return (
                                        <TableRow tabIndex={-1} key={index}>
                                            {headData.map(col => (
                                                col.id === 'count' ? <CustomTableCell>{count}</CustomTableCell> :
                                                    <CustomTableCell>{row[col.id]}</CustomTableCell>
                                            ))}
                                        </TableRow>
                                    );
                                })}
                                {emptyRows > 0 && (
                                    <TableRow style={{height: emptyRows}}>
                                        <TableCell colSpan={headData.length}/>
                                    </TableRow>
                                )}
                            </> : <TableRow><TableCell align='center'  {...{colSpan: headData.length}}>No records
                                found</TableCell></TableRow> : null}
                        {isError ?
                            <TableRow><TableCell align='center'  {...{colSpan: headData.length}}>The server did not
                                return a valid response</TableCell></TableRow> : null}
                    </StickyHeadTable>
                </MuiPaper>
            </Container>

        </div>
    )
};

function mapStateToProps(state) {
    return {snackbars: state.snackbar}
}

function mapDispatchToProps(dispatch) {
    return {actions: {snackbarActions: bindActionCreators(snackbarActions, dispatch)}}
}

export default connect(mapStateToProps, mapDispatchToProps)(DebtorsAgeingReport);
